import React, { FC } from "react";
import "./HomePage.style.css";

export const HomePage: FC = () => {
  return (
    <div className="homepage-content">
      <h1>Code Assertion Limited</h1>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>

      <h2>Some section 1 content</h2>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>

      <h2>Some section 2 content</h2>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
      <p>
        IT Consultancy specializing in .NET and Java solutions, On-Premises or
        in the Cloud and all the current market buzzwords:)
      </p>
    </div>
  );
};

export default HomePage;
